/**
 * Connection Button Component
 */

import { useBluetooth } from '../../hooks/useBluetooth'
import { Button } from '../Common/Button'

export function ConnectionButton() {
  const { isSupported, isConnected, isConnecting, connect, disconnect } = useBluetooth()

  if (!isSupported) {
    return (
      <div className="px-4 py-2 bg-red-100 dark:bg-red-900/20 text-red-800 dark:text-red-200 rounded-lg text-sm">
        Web Bluetooth not supported in this browser
      </div>
    )
  }

  if (isConnected) {
    return (
      <Button variant="secondary" onClick={disconnect}>
        Disconnect
      </Button>
    )
  }

  return (
    <Button onClick={connect} disabled={isConnecting}>
      {isConnecting ? 'Connecting...' : 'Connect to M-Scale'}
    </Button>
  )
}
